import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cartTotal'
})
export class CartTotalPipe implements PipeTransform {

  transform(value) {
        let total = 0;
        if (value) {
            value.forEach(cartItem => {
                total += 1 *  cartItem.product.mp3_price;
            });
        }
        return total;
    }

}



// WEBPACK FOOTER //
// ./src/app/cart/pipes/cart-total.pipe.ts